import { defineMessage } from '../../../../services/localization';

export const messages = {
    empty: defineMessage('nothing_added'),
    emptySearchMessage: defineMessage('no_results_found'),
};
